module.exports = __webpack_public_path__ + "static/media/Pruebas_automatizadas.5194cd26.png";